import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { Grid, GridItem } from '../../helpers';
import { ModuleHeader } from '../../primitives';
import { ImageInterface } from '~/types';
import { ImageWithCaption, YoutubeVideo } from '../../components';
import Slider from '../Slider';

const StyledImage = styled(ImageWithCaption)`
  .gatsby-image-wrapper {
    aspect-ratio: 1;
  }
`;

const Gallery = (galleryProps: GalleryProps) => {
  const { title, items } = galleryProps;

  return (
    <div className="m-gallery">
      <Grid columns={{ zero: 12 }}>
        {title && (
          <GridItem
            size={{ zero: 12, medium: 10, large: 8 }}
            push={{ zero: 0, medium: 1, large: 2 }}
          >
            <ModuleHeader title={title} />
          </GridItem>
        )}
        <GridItem size={12} push={0}>
          <Slider showHiddenSlides slidesPerView={3}>
            {items.map((item: GalleryItem, index: number) => (
              <Fragment key={index}>
                {'image' in item ? (
                  <StyledImage key={index} data={item} />
                ) : (
                  <YoutubeVideo
                    youtubeVideoId={item.youtubeVideoId}
                    isResponsive
                  />
                )}
              </Fragment>
            ))}
          </Slider>
        </GridItem>
      </Grid>
    </div>
  );
};

type GalleryItem = ImageInterface | { youtubeVideoId: string };

export type GalleryProps = {
  title?: string;
  items: GalleryItem[];
};

export default Gallery;
